import { TypographyOptions } from "@material-ui/core/styles/createTypography";
import { AppColor } from "./app-color";

const typography: TypographyOptions = {
  fontFamily: [
    "Noto Sans",
    "Noto Sans Thai",
    "Inter",
    "-apple-system",
    "BlinkMacSystemFont",
    '"Segoe UI"',
    "Roboto",
    '"Helvetica Neue"',
    "Arial",
    "sans-serif",
    '"Apple Color Emoji"',
    '"Segoe UI Emoji"',
    '"Segoe UI Symbol"',
  ].join(","),
  fontSize: 16,
  fontWeightLight: 300,
  fontWeightRegular: 400,
  fontWeightMedium: 500,
  fontWeightBold: 600,
  // allVariants: {
  //   overflow: "hidden",
  //   whiteSpace: "nowrap",
  //   textOverflow: "ellipsis",
  // },
  h1: {
    fontSize: 32,
    fontWeight: 600,
    lineHeight: 1.2,
  },
  h2: {
    fontSize: 28,
    fontWeight: 600,
    lineHeight: 1.2,
  },
  h3: {
    fontSize: 24,
    fontWeight: 600,
    lineHeight: 1.2,
  },
  h4: {
    fontSize: 20,
    fontWeight: 600,
    lineHeight: "24px",
  },
  h5: {
    fontSize: "1.0625rem",
    fontWeight: 600,
    lineHeight: 1.25,
  },
  h6: {
    fontSize: 16,
    fontWeight: 600,
    lineHeight: 1.25,
    letterSpacing: -0.4,
  },
  body1: {
    fontSize: 16,
    fontWeight: 400,
    lineHeight: 1.25,
  },
  body2: {
    fontSize: 16,
    fontWeight: 700,
    lineHeight: 1.25,
  },
  caption: {
    fontSize: 12,
    fontWeight: "normal",
    lineHeight: 1.167,
  },
  button: {
    textTransform: "none",
  },
};

export default typography;
